export default __webpack_public_path__ + "static/media/a038-7.18be4830.svg";